<template>
    <div id="app">
        <LoadingAnim v-if="is_loading"/>
        <div class="main">
            <TempHeader :bootup="bootup" @openHelp="openHelp = true"/>
            <div class="content_container">
                <Simulator />
                <StartPage v-if="bootup" @toggleStartPage="toggleStartPage"/>
            </div>
            <transition name="fade">
                <HelpPanel v-show="openHelp" @close="openHelp = false"/>
            </transition>
        </div>
        <Caution v-if="screenOrientation"/>
        <DlSource v-if="is_creating_image"/>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex'
    import TempHeader from "./components/template/TempHeader"
    import Simulator from "./components/template/Simulator"
    import HelpPanel from "./components/template/HelpPanel"
    import LoadingAnim from "./components/template/LoadingAnim"
    import {loadImage} from "./assets/js/loadImageByPromise"
    import SampleScene from "./assets/js/SampleScene"
    import Util from "./assets/js/util"
    import CONST from "./assets/js/const"
    import DlSource from "./components/modal/DlSource"

    export default {
        name: 'App',
        components: {
            TempHeader,
            Simulator,
            HelpPanel,
            LoadingAnim,
            DlSource,
            Caution:() => import("./components/template/Caution.vue"),
            StartPage: () => import("./components/template/StartPage.vue")
        },
        mounted: function() {
            var _this = this;
            window.addEventListener('load', (event) => {
                _this.toggleCaution();
            });
            window.addEventListener('orientationchange', function(){
                _this.toggleCaution();
                }
            );
        },
        computed: {
            ...mapState(['is_creating_image']),
            is_loading() { return this.$store.state.is_loading },
        },
        data () {
            return {
                bootup: true,
                screenOrientation: false,
                openHelp: false
            }
        },
        async created() {
            this.$store.commit('setIsLoading', true);
            // 商品データをまとめて読み込む
            await this.loadItemData();
            const img = await loadImage(`${CONST.BASE_URL}assets/images/scenes/living/living_5_1.jpg`); //シーン初期画像
            // const img = await loadImage(`${CONST.BASE_URL}assets/images/${SampleScene.initial_background_image}`);
            this.$store.commit('setBackgroundImage', img);

            if ( this.checkSaveData() && !this.bootup) {
                this.init();
                // this.restoreEditDataFromLocalStorage();
                // if (confirm('前回の編集データがあります。\n復元しますか？')) {
                //     this.restoreEditDataFromLocalStorage();
                // } else {
                //     localStorage.removeItem(CONST.LOCAL_STORAGE_KEY);
                //     localStorage.removeItem(CONST.LOCAL_STORAGE_IMG_KEY);
                // }
            }
            else {
                this.init();
            }

            //初回起動、大体すぐだが短すぎても操作感が悪いので手動で待つ（仮）
            setTimeout(()=>this.$store.commit('setIsLoading', false), 500);
            this.resetTimer();

        },
        methods: {
            ...mapMutations('simulator', ['createNewItem']),
            ...mapActions('simulator', ["restoreEditDataFromLocalStorage", "init"]),
            ...mapActions('item_data', ["loadItemData"]),
            ...mapActions(["setBackgroundImage", "resetTimer"]),
            checkSaveData() {
                return (
                    Util.checkLocalStorageAvailable()
                    && (
                        localStorage.getItem(CONST.LOCAL_STORAGE_KEY)
                        || localStorage.getItem(CONST.LOCAL_STORAGE_IMG_KEY)
                    )
                )
            },
            toggleStartPage () {
                this.bootup = !this.bootup
            },
            toggleCaution(){
                const ua = navigator.userAgent;
                const isMobile = ua.indexOf('iPhone') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0 || ua.indexOf('Mobile') > 0;
                const clientWidth = window.parent.screen.width;
                const clientHeight = window.parent.screen.height;
                if (isMobile && (Math.abs(Number(window.orientation || 0)) !== 90) && clientWidth < clientHeight ) {
                    this.screenOrientation = true;
                } else {
                    this.screenOrientation = false;
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "assets/css/define";
    #app {
        .main{
            display: grid;
            grid-template-columns: 100%;
            grid-template-rows: 57px calc(100dvh - 57px);
            grid-template-rows: 57px calc(100vh - 57px);
            padding: 0;
            min-width: 667px;
            height: 100vh;
            height: 100dvh;
            .content_container {
                position: relative;
                display: grid;
                grid-template-columns: 100%;
                /*grid-template-rows: 1fr 54px;*/
            }
        }
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s;
    }
</style>
